import React from "react";
import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
// Bottom sheet: enters/leaves from the bottom; grab handle signals the dismiss gesture.
export function BottomMobileModal({ children, open, setOpen }) {
    return (<Transition show={open}>
            <Dialog as="div" className="relative z-40" onClose={setOpen}>
                <TransitionChild enter="transition-opacity ease-out-soft duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-out-soft duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-[2px]"/>
                </TransitionChild>

                <div className="fixed inset-0 z-40 flex flex-col">
                    <DialogPanel className="relative flex h-full w-full flex-1 flex-col">
                        <section className={"grow shrink"} onClick={() => setOpen(false)}/>

                        {/* Transition wraps the sheet, not the full-viewport panel — translate-y-full is relative to its own height. */}
                        <TransitionChild enter="transform transition-transform ease-out-soft duration-200" enterFrom="translate-y-full" enterTo="translate-y-0" leave="transform transition-transform ease-out-soft duration-150" leaveFrom="translate-y-0" leaveTo="translate-y-full">
                            <section className={"flex max-h-[92dvh] flex-col rounded-t-2xl bg-white px-5 pb-safe pt-2 shadow-overlay"}>
                                <div aria-hidden={"true"} className={"mx-auto mb-3 h-1 w-9 shrink-0 rounded-full bg-line-strong"}/>
                                <div className={"flex min-h-0 grow flex-col overflow-y-auto overscroll-contain pb-5"}>{children}</div>
                            </section>
                        </TransitionChild>
                    </DialogPanel>
                </div>
            </Dialog>
        </Transition>);
}
//# sourceMappingURL=bottomMobileModal.jsx.map